import { useCardProductLang } from './useCardProductLang';

export function useCardProduct() {
  const lang = useCardProductLang();
  return {
    lang,
  };
}
